import { thumbHashToRGBA } from 'thumbhash';

class W4D_ThumbHashCanvas {
	constructor() {
		this.attempted = new WeakSet();
		this.cartImages = new WeakSet();
		this.observer =
			typeof IntersectionObserver === 'function'
				? new IntersectionObserver((entries) => this.handleEntries(entries), { rootMargin: '300px' })
				: null;

		this.observeCanvases();
		this.bindEvents();
	}

	observeCanvases() {
		document.querySelectorAll('.thumbhash-canvas').forEach((canvas) => {
			this.trackCartImage(canvas);
			if (this.attempted.has(canvas)) return;

			if (this.observer) {
				this.observer.observe(canvas);
			} else {
				this.render(canvas);
			}
		});
	}

	trackCartImage(canvas) {
		const thumbnail = canvas.closest('.cart__item-thumbnail');
		const img = thumbnail?.querySelector('img');
		if (!img || this.cartImages.has(img)) return;

		this.cartImages.add(img);
		const settle = () => {
			if (img.naturalWidth > 0) thumbnail.classList.add('cart__item-thumbnail--loaded');
		};
		img.addEventListener('load', settle, { once: true });
		if (img.complete) settle();
	}

	bindEvents() {
		if (typeof document === 'undefined') return;

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => this.observeCanvases(), { once: true });
		}

		document.addEventListener('w4d_shop_updated', () => this.observeCanvases());
		if (typeof jQuery !== 'undefined') {
			jQuery(document).ajaxComplete(() => this.observeCanvases());
		}
	}

	handleEntries(entries) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) return;

			this.observer.unobserve(entry.target);
			this.render(entry.target);
		});
	}

	render(canvas) {
		if (!(canvas instanceof HTMLCanvasElement) || this.attempted.has(canvas)) return;

		this.attempted.add(canvas);

		try {
			const thumbhash = canvas.dataset.thumbhash;
			if (!thumbhash || !/^[A-Za-z0-9+/_-]+$/.test(thumbhash) || typeof atob !== 'function') return;

			const bytes = this.base64ToBytes(thumbhash);
			if (bytes.length < 5) return;

			const { w, h, rgba } = thumbHashToRGBA(bytes);
			if (!Number.isInteger(w) || !Number.isInteger(h) || w < 1 || h < 1 || rgba.length !== w * h * 4) return;

			// Set internal buffer size directly to intrinsic hash dimensions (e.g., 32x24)
			canvas.width = w;
			canvas.height = h;

			const context = canvas.getContext('2d');
			if (!context) return;

			// Single direct pixel paste (no extra canvas allocations, no JS blur, no reflow)
			context.putImageData(new ImageData(new Uint8ClampedArray(rgba), w, h), 0, 0);
		} catch {
			return;
		}
	}

	base64ToBytes(value) {
		const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
		const decoded = atob(normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '='));
		return Uint8Array.from(decoded, (character) => character.charCodeAt(0));
	}
}

window.W4D_ThumbHashCanvas = new W4D_ThumbHashCanvas();
